@if (useAccordionComponent) {
  <mat-accordion>
    <mat-expansion-panel (opened)="panelOpenState.set(true)"
                         (closed)="panelOpenState.set(false)"
                         [expanded]="toggleAccordion"
                         togglePosition="before" class="border-2">
      <mat-expansion-panel-header class="min-h-[100px] bg-brandLightBlueFill dark:bg-gray-700">
        <div class="flex flex-row justify-between items-center w-full">
          <div class="flex flex-col">
            <span class="font-bold text-xl dark:text-white">{{ getCompanyName() }}</span>
            @if (getCompanyDBA()) {
              <span class="font-semibold text-md">DBA: {{ getCompanyDBA() }}</span>
            }
            <span class="font-medium text-sm text-gray-400 dark:text-gray-400">
              {{ getStateAndBondLabel() }}
              @if (getEffectiveDate()) {
                | Effective Date: {{ getEffectiveDate() | date : 'shortDate' }}
              }
            </span>
          </div>
          <div class="flex flex-col align-right text-right">
            <p class="text-lg font-bold" *ngIf="getPremium() > 0">
              {{ getPremium() | currency: 'USD' }}
            </p>
            <p class="accent-green-500 text-sm text-primary">
              {{ getDurationTerm() }}
            </p>
            @if (item.showQuantity) {
            <div class="flex items-center gap-2 mt-2">
              <span class="text-sm text-gray-500">Qty:</span>
              <div class="flex items-center gap-1">
                <button mat-icon-button
                        (click)="onQuantityChange(item.quantity - 1)"
                        [disabled]="item.quantity <= 1"
                        class="w-6 h-6">
                  <mat-icon class="text-sm">remove</mat-icon>
                </button>
                <span class="mx-2 font-semibold">{{ item.quantity }}</span>
                <button mat-icon-button
                        (click)="onQuantityChange(item.quantity + 1)"
                        class="w-6 h-6">
                  <mat-icon class="text-sm">add</mat-icon>
                </button>
                </div>
              </div>
            }
          </div>
        </div>
      </mat-expansion-panel-header>

      <div class="rounded-lg px-2">
        <div class="w-full flex flex-col justify-between pt-4">
          <!--Item Details-->
          <div class="flex flex-row justify-between">
            <span class="font-semibold text-lg my-4">Item Details</span>
            <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Item Actions Menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button
                mat-menu-item
                *ngFor="let _item of menuItems"
                [disabled]="!_item.enabled"
                (click)="onMenuItemClick(_item)">
                <mat-icon *ngIf="_item.icon">{{ _item.icon }}</mat-icon>
                <span>{{ _item.label }}</span>
              </button>
            </mat-menu>
          </div>

          <div class="grid grid-cols-2 gap-4">
            <!-- Order Number -->
            <div>
              <p class="text-sm font-medium text-gray-400 dark:text-white">Order Number</p>
              <p class="text-md font-semibold text-green-500">{{ getOrderNumber() }}</p>
            </div>

            <!-- Date Ordered -->
            <div>
              <p class="text-sm font-medium text-gray-400 dark:text-white">Date Ordered</p>
              <p class="text-md font-semibold text-gray-500">{{ getQuoteRequestDate() | date : 'MM/dd/yyyy' }}</p>
            </div>

            <!-- Company Type -->
            <div>
              <p class="text-sm font-medium text-gray-400 dark:text-white">Company Type</p>
              <p class="text-md font-semibold text-gray-500">{{ getCompanyType() }}</p>
            </div>

            <!-- Principal Address -->
            <div>
              <p class="text-sm font-medium text-gray-400 dark:text-white">Principal Address</p>
              <p class="text-md font-semibold text-gray-500">{{ getFormattedAddress() }}</p>
            </div>
          </div>
          <mat-divider class="my-4"></mat-divider>

          <!--Bond Owner-->
          <span class="font-semibold text-lg my-4">Bond Owner</span>
          <div class="grid grid-cols-2 gap-4">
            <!-- Owner -->
            <div>
              <p class="text-sm font-medium text-gray-400 dark:text-white">Owner</p>
              <p class="text-md font-semibold">{{ getOwnerName() }}</p>
            </div>

            <div>
              <p class="text-sm font-medium text-gray-400 dark:text-white">Contact</p>
              <p class="text-md font-semibold text-gray-500">{{ getOwnerPhone() }}</p>
            </div>
          </div>
          <mat-divider class="my-4"></mat-divider>

          <!--Pricing Details-->
          <span class="font-semibold text-lg my-4">Pricing</span>
          <div class="border-1 rounded-lg border-gray-600 overflow-hidden p-4">
            <div class="flex flex-row justify-between items-center mb-2">
              <span class="text-md">Item Price:</span>
              <span class="font-semibold">{{ item.price | currency: 'USD' }}</span>
            </div>
            <div class="flex flex-row justify-between items-center mb-2">
              <span class="text-md">Quantity:</span>
              <span class="font-semibold">{{ item.quantity }}</span>
            </div>
            <div class="flex flex-row justify-between items-center mb-2">
              <span class="text-md">Subtotal:</span>
              <span class="font-semibold">{{ item.getSubtotal() | currency: 'USD' }}</span>
            </div>
            @if (item.getTax() > 0) {
              <div class="flex flex-row justify-between items-center mb-2">
                <span class="text-md">Tax:</span>
                <span class="font-semibold">{{ item.getTax() | currency: 'USD' }}</span>
              </div>
            }
            @if (item.getShipping() > 0) {
              <div class="flex flex-row justify-between items-center mb-2">
                <span class="text-md">Shipping:</span>
                <span class="font-semibold">{{ item.getShipping() | currency: 'USD' }}</span>
              </div>
            }
            <mat-divider class="my-2"></mat-divider>
            <div class="flex flex-row justify-between items-center">
              <span class="text-lg font-bold">Total:</span>
              <span class="text-lg font-bold text-green-600">{{ item.getTotalWithTaxAndShipping() | currency: 'USD' }}</span>
            </div>
          </div>

          <!--Bond Delivery-->
          <div class="my-4">
            <span class="font-semibold text-lg">Bond Delivery</span>
            <p class="text-sm text-gray-400 dark:text-white">Delivery Method</p>
            <span class="bg-orange-300 dark:bg-brandOrange dark:text-white px-4 py-1 rounded-md w-fit">
              {{ getShippingOption() }}
            </span>
          </div>

          <!--Attached Files-->
          <div class="my-4" *ngIf="hasAttachedFiles()">
            <span class="font-semibold text-lg my-4">
              Attached File{{ getAttachedFiles().length > 1 ? 's (' + getAttachedFiles().length + ')' : '' }}
            </span>
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
              <mat-card *ngFor="let file of getAttachedFiles()"
                        class="cursor-pointer hover:bg-slate-50"
                        [matTooltip]="file.file_friendly_name">
                <mat-card-content>
                  <p class="underline truncate flex flex-row items-center">
                    <span class="micon">
                      <mat-icon *ngIf="file.file_extension === 'pdf'" class="mr-2">picture_as_pdf</mat-icon>
                      <mat-icon *ngIf="file.file_extension === 'doc' || file.file_extension === 'docx'" class="mr-2">
                        description
                      </mat-icon>
                      <mat-icon *ngIf="file.file_extension === 'jpg' || file.file_extension === 'png'" class="mr-2">
                        image
                      </mat-icon>
                      <mat-icon *ngIf="!['pdf','doc','docx','jpg','png'].includes(file.file_extension)" class="mr-2">
                        insert_drive_file
                      </mat-icon>
                    </span>
                    <b>({{ file.related_file_type_label }}) </b>
                    {{ file.file_friendly_name }}
                  </p>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
} @else {
  <!-- Compact view without accordion -->
  <div class="px-4 py-2 rounded-lg border-2 min-h-[100px] bg-brandLightBlueFill dark:bg-gray-700">
    <div class="flex flex-row justify-between items-center w-full">
      <div class="flex flex-col">
        <span class="font-bold text-xl dark:text-brandBlue">{{ getCompanyName() }}</span>
        @if (getCompanyDBA()) {
          <span class="font-semibold text-md">DBA: {{ getCompanyDBA() }}</span>
        }
        <span class="font-medium text-sm text-gray-400 dark:text-white">
          {{ getStateAndBondLabel() }}
          @if (getEffectiveDate()) {
            | Effective Date: {{ getEffectiveDate() | date : 'shortDate' }}
          }
        </span>
      </div>
      <div class="flex flex-col align-right text-right">
        <p class="text-lg font-bold" *ngIf="getPremium() > 0">
          {{ getPremium() | currency: 'USD' }}
        </p>
        <p class="accent-green-500 text-sm text-primary">{{ getDurationTerm() }}</p>
        <div class="flex items-center gap-2 mt-2">
          <span class="text-sm text-gray-500">Qty: {{ item.quantity }}</span>
          <button mat-icon-button (click)="onRemoveItem()" class="text-red-500">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
}
